<div class="row">
    <div class="column col-12">
        <div class="content-wrapper section-wrapper">
            <h1>{{name}}</h1>
            <p>{{content}}</p>
            <ng-content></ng-content>
        </div>
    </div>
</div>